/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Row, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Cookies from 'js-cookie';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import YesNoSwitch from 'components/input/YesNoSwitch';
import TextInput from 'components/input/textInput';
import * as Yup from 'yup';
import SelectInput from 'components/input/SelectInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import TextAreaInput from 'components/input/TextAreaInput';
import { checkEnableParseJSON } from 'components/helper/helper';
import { debounce } from 'lodash';
import {
  getEducationalProgram,
  updateEducationalProgram,
} from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import Grid from '@mui/joy/Grid';
import websocketService from 'services/websocketService';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

const rules = Yup.object({
  year_participated_in_AVID: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_upward_bound: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_talent_search: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_puente_project: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_ilp: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_MESA_project: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  year_participated_in_other_program: Yup.number().min(1, 'Invalid').max(99, 'Invalid'),
  number_brothers_and_sisters_k12: Yup.number().min(0, 'Invalid').integer('Invalid'),
  number_brothers_and_sisters_college: Yup.number().min(0, 'Invalid').integer('Invalid'),
  number_brothers_and_sisters_received_bachelor_degree: Yup.number()
    .min(0, 'Invalid')
    .integer('Invalid'),
  number_year_received_income: Yup.number().min(1, 'Invalid').max(99, 'Invalid').integer('Invalid'),
});
interface Props {}

const EducationalPrograms = (props: Props) => {
  const activitiesAndHonors = useAppSelector((store) => store.activitiesAndHonors);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');

  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  let studentId = getUserId();
  let token = getAccessToken();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.EDUCATIONAL_PROGRAMS, newValue);
  }
  const formik = useFormik({
    initialValues: {
      avid: '',
      year_participated_in_AVID: '',
      upward_bound: '',
      year_participated_in_upward_bound: '',
      talent_search: '',
      year_participated_in_talent_search: '',
      puente_project: '',
      year_participated_in_puente_project: '',
      ilp: '',
      year_participated_in_ilp: '',
      MESA_project: '',
      year_participated_in_MESA_project: '',
      other_program: '',
      year_participated_in_other_program: '',
      average_hours_worked_per_week: '',
      is_more_25_percent_work_related_major: '',
      average_hours_activities_per_week: '',
      is_leadership_positions: '',
      wish_to_apply_EOP: '',
      is_enrolled_EOP: '',
      where_plan_to_live: '',
      number_brothers_and_sisters_k12: '',
      number_brothers_and_sisters_college: '',
      number_brothers_and_sisters_received_bachelor_degree: '',
      languages_spoken_in_home: '',
      is_received_income_from_public_assistance_program: '',
      number_year_received_income: '',
      type_of_aid: '',
      is_participated_in_publicly_funded_programs: '',
      publicly_funded_programs: '',
      is_work_primarily_to_contribute: '',
      work_primarily_to_contribute: '',
      campus_enrolled_EOP: '',
    },
    validationSchema: rules,
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        const newValues = {
          csu_info: JSON.stringify(values),
          student_id: studentId,
        };
        await dispatch(updateEducationalProgram(newValues));
      } else {
        handleLogout();
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.responsibilitiesAndCircumstances.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.EDUCATIONAL_PROGRAMS);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let res = await dispatch(getEducationalProgram(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = checkEnableParseJSON(dataLoaded.csu_info);
        formik.setValues({ ...formik.values, ...values });
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'Work Information', specialId: 'Work_Information' },
          { percentOnProcess: 60, title: 'Extracurricular & Leadership Participation', 
            specialId: 'Extracurricular_Leadership_Participation',
            maxWidth: 180 
          },
          { percentOnProcess: 90, title: 'EOP', specialId: 'EOP' },
        ]}
        title="Educational Programs Participation"
        process={1}
        icon={<StackedLineChartIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-1' : 'mb-2'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Educational Programs Participation
              </span>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Work_Information" className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'} p-1`}>Work Information</div>
                </Grid>
                <Grid xs={12}>
                  <SelectInput
                    disabled={reviewedAndComplete}
                    logo="span-csu-logo"
                    mdCol="12"
                    option={[
                      'Select',
                      '0 hours',
                      '1-5 hours',
                      '6-10 hours',
                      '11-15 hours',
                      '16-20 hours',
                      '21 or more hours',
                    ]}
                    label="What was the average number of hours worked per week over the most recent 36 months?*"
                    name="average_hours_worked_per_week"
                    onChange={formik.handleChange}
                    values={formik.values.average_hours_worked_per_week}
                    isMissing={
                      (!formik.values.average_hours_worked_per_week ||
                        formik.values.average_hours_worked_per_week === 'Select') &&
                      check
                    }
                    isCMLogo={true}
                  />
                </Grid>
                <Grid xs={12}>
                  <YesNoSwitch
                    logo="span-csu-logo"
                    disabled={reviewedAndComplete}
                    hidden={
                      formik.values.average_hours_worked_per_week === 'Select' ||
                      formik.values.average_hours_worked_per_week === '0 hours'
                    }
                    label="Was more than 25% of your work hours related to your major of choice?*"
                    name="is_more_25_percent_work_related_major"
                    onChange={formik.handleChange}
                    values={formik.values.is_more_25_percent_work_related_major}
                    isMissing={!formik.values.is_more_25_percent_work_related_major && check}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields"></Grid>
              <Grid xs={12}>
                <div className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'} p-1`}>
                  Extracurricular Programs Hours of Participation and Leadership
                </div>
              </Grid>
              <Grid id="Extracurricular_Leadership_Participation" xs={12}>
                <div className="text-field-light">
                  Extracurricular Programs and leadership participation includes activities such as
                  arts, Asian American Club, Boy Scouts/Girl Scouts, Boy's Week/Girl's Week,
                  cheerleading, drama/theater, inter-scholastic athletics, marching band, MEChA,
                  Pride Club, science club, student government, yearbook, Young Democrats/Young
                  Republicans and all other extracurricular activities.
                </div>
              </Grid>
              <Grid xs={12}>
                <SelectInput
                  logo="span-csu-logo"
                  disabled={reviewedAndComplete}
                  isCMLogo={true}
                  mdCol="12"
                  option={[
                    'Select',
                    '0 hours',
                    '1-5 hours',
                    '6-10 hours',
                    '11-15 hours',
                    '16-20 hours',
                    '21 or more hours',
                  ]}
                  label="Select the average number of hours per week you are/were involved in activities during the last 36 months.*"
                  name="average_hours_activities_per_week"
                  onChange={formik.handleChange}
                  values={formik.values.average_hours_activities_per_week}
                  isMissing={
                    (!formik.values.average_hours_activities_per_week ||
                      formik.values.average_hours_activities_per_week === 'Select') &&
                    check
                  }
                />
              </Grid>
              <Grid xs={12} className='mt-2'>
                <YesNoSwitch
                  logo="span-csu-logo"
                  disabled={reviewedAndComplete}
                  hidden={
                    formik.values.average_hours_activities_per_week === 'Select' ||
                    formik.values.average_hours_activities_per_week === '0 hours' ||
                    formik.values.average_hours_activities_per_week === ''
                  }
                  label="Did you hold or have you held any leadership positions in those activities, e.g. class president, club president, team captain, yearbook editor, etc.?*"
                  name="is_leadership_positions"
                  onChange={formik.handleChange}
                  values={formik.values.is_leadership_positions}
                  isMissing={!formik.values.is_leadership_positions && check}
                />
              </Grid>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'} p-1`}>Important Reminder</div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    Applicants may complete and submit their Cal State Apply application and then
                    later return to complete the EOP portion of the application. To ensure that you
                    submit your EOP application on time, please refer to the EOP Admission by Term
                    page for campus specific information.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    If you are applying to EOP after you have already submitted your main
                    application, you must return to the dashboard and click on the blue 'submit my
                    changes' button in order for your updates to be received by Cal State Apply
                    staff. Only updates to your EOP application will be considered after your
                    initial submission.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'}`}>Educational Opportunity Program (EOP)</div>
                </Grid>
                <Grid id="EOP" xs={12}>
                  <div className="text-field-light my-2">
                    The primary goal of the CSU Educational Opportunity Program is to improve access
                    of low-income, first-generation, and historically disadvantaged students from
                    California with potential for academic success by making higher education a
                    possibility.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    Visit the EOP Admissions site to learn more about EOP, eligibility criteria, and
                    to view EOP application deadlines.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    Select Yes to apply to EOP. Your EOP application is not considered complete
                    until you complete the three EOP sections and provide two recommenders.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    Visit the Applicant Help Center for more information.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    If you have yet to submit any applications for fall 2023, you must complete all
                    EOP sections below before submitting your application. You cannot return later
                    to complete these EOP questions. EOP recommendations are due two-weeks after the
                    campus deadline.
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light my-2">
                    If you already submitted a campus application and would like to apply to an EOP
                    program that is still accepting EOP applications, contact the campus EOP office
                    directly for instructions on how to apply.
                  </div>
                </Grid>
                <Grid xs={12}>

                  <GroupRadioButton
                    disabled={reviewedAndComplete}
                    verticalLayout={true}
                    logo="span-csu-logo"
                    mdCol={12}
                    options={[
                      'Yes',
                      'Yes, I will return later to complete these EOP questions',
                      'No',
                    ]}
                    label="Do you wish to apply to the Educational Opportunity Program (EOP)?*"
                    name="wish_to_apply_EOP"
                    onChange={formik.handleChange}
                    values={formik.values.wish_to_apply_EOP}
                    isMissing={!formik.values.wish_to_apply_EOP && check}
                  />
                </Grid>
                <Grid xs={12}>
                  <div className="text-field-light">
                    Selecting No after you have saved responses on this page will result in the loss
                    of your saved responses.
                  </div>
                </Grid>
                {formik.values.wish_to_apply_EOP === 'Yes' && (
                  <>
                    <Grid xs={12}>
                      <GroupRadioButton
                        columns={3}
                        logo="span-csu-logo"
                        mdCol={12}
                        options={['Yes', 'No', 'Not Applicable']}
                        label="If you attended a CSU were you enrolled in an EOP program?*"
                        name="is_enrolled_EOP"
                        onChange={formik.handleChange}
                        values={formik.values.is_enrolled_EOP}
                        isMissing={!formik.values.is_enrolled_EOP && check}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                    {formik.values.is_enrolled_EOP === 'Yes' && (
                      <Grid xs={12}>
                        <SelectInput
                          disabled={reviewedAndComplete}
                          option={[
                            'Bakersfield',
                            'Channel Islands',
                            'Chico',
                            'Dominguez Hills',
                            'East Bay',
                            'Fresno',
                            'Fullerton',
                            'Humboldt',
                            'Long Beach',
                            'Los Angeles',
                            'Maritime Academy',
                            'Monterey',
                            'Northridge',
                            'Pomona',
                            'Sacramento',
                            'San Bernardino',
                            'San Diego',
                            'San Francisco',
                            'San Jose',
                            'San Luis Obispo',
                            'San Marcos',
                            'Sonoma',
                            'Stanislaus',
                          ]}
                          label="Select the campus:*"
                          name="campus_enrolled_EOP"
                          onChange={formik.handleChange}
                          values={formik.values.campus_enrolled_EOP}
                          isMissing={!formik.values.campus_enrolled_EOP && check}
                        />
                      </Grid>
                    )}
                    <Grid xs={12}>
                      <SelectInput
                        disabled={reviewedAndComplete}
                        option={[
                          'Select',
                          'On-Campus Housing',
                          'With Parents',
                          'Off-campus apartment or house',
                          'Other',
                        ]}
                        label={`Where do you plan to live while attending college? (Select one):*`}
                        isLongLableText={true}
                        name="where_plan_to_live"
                        onChange={formik.handleChange}
                        values={formik.values.where_plan_to_live}
                        isMissing={!formik.values.where_plan_to_live && check}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextInput
                        disabled={reviewedAndComplete}
                        type="number"
                        decimalStep={1}
                        label="How many brothers and sisters are currently attending a K-12 school?*"
                        setLabelHight={true}
                        values={formik.values.number_brothers_and_sisters_k12}
                        name="number_brothers_and_sisters_k12"
                        onChange={formik.handleChange}
                        isMissing={!formik.values.number_brothers_and_sisters_k12 && check}
                        feedback={
                          <span className="text-danger">
                            {formik.errors.number_brothers_and_sisters_k12}
                          </span>
                        }
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextInput
                        disabled={reviewedAndComplete}
                        type="number"
                        decimalStep={1}
                        label="How many brothers and sisters are currently attending or attended college?*"
                        setLabelHight={true}
                        values={formik.values.number_brothers_and_sisters_college}
                        name="number_brothers_and_sisters_college"
                        onChange={formik.handleChange}
                        isMissing={!formik.values.number_brothers_and_sisters_college && check}
                        feedback={
                          <span className="text-danger">
                            {formik.errors.number_brothers_and_sisters_college}
                          </span>
                        }
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextInput
                        disabled={reviewedAndComplete}
                        type="number"
                        decimalStep={1}
                        label="How many brothers and sisters received a bachelor's degree?*"
                        setLabelHight={true}
                        values={formik.values.number_brothers_and_sisters_received_bachelor_degree}
                        name="number_brothers_and_sisters_received_bachelor_degree"
                        onChange={formik.handleChange}
                        isMissing={
                          !formik.values.number_brothers_and_sisters_received_bachelor_degree &&
                          check
                        }
                        feedback={
                          <span className="text-danger">
                            {formik.errors.number_brothers_and_sisters_received_bachelor_degree}
                          </span>
                        }
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextAreaInput
                        disabled={reviewedAndComplete}
                        countText={60}
                        mdCol="12"
                        label="What languages are spoken in your home?*"
                        values={formik.values.languages_spoken_in_home}
                        name="languages_spoken_in_home"
                        onChange={formik.handleChange}
                        isMissing={!formik.values.languages_spoken_in_home && check}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <YesNoSwitch
                        logo="span-csu-logo"
                        disabled={reviewedAndComplete}
                        values={formik.values.is_received_income_from_public_assistance_program}
                        name="is_received_income_from_public_assistance_program"
                        onChange={formik.handleChange}
                        isMissing={
                          !formik.values.is_received_income_from_public_assistance_program && check
                        }
                        label="During the past 10 years, have you or your family received any income from a public assistance program such as CalWorks, CalFresh, welfare, AFDC, TANF, Social Security, disability, etc.?*"
                      />
                    </Grid>
                    {formik.values.is_received_income_from_public_assistance_program === 'true' && (
                      <>
                        <Grid xs={12}>
                          <TextInput
                            type="number"
                            disabled={reviewedAndComplete}
                            label="If yes, how many years?*"
                            setLabelHight={true}
                            values={formik.values.number_year_received_income}
                            name="number_year_received_income"
                            isMissing={!formik.values.number_year_received_income && check}
                            onChange={formik.handleChange}
                            feedback={
                              <span className="text-danger">
                                {formik.errors.number_year_received_income}
                              </span>
                            }
                          />
                        </Grid>
                        <Grid xs={12}>
                          <TextInput
                            disabled={reviewedAndComplete}
                            countText={49}
                            label="Type(s) of aid:*"
                            setLabelHight={true}
                            values={formik.values.type_of_aid}
                            name="type_of_aid"
                            isMissing={!formik.values.type_of_aid && check}
                            onChange={formik.handleChange}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid xs={12}>
                      <YesNoSwitch
                        logo="span-csu-logo"
                        disabled={reviewedAndComplete}
                        values={formik.values.is_participated_in_publicly_funded_programs}
                        name="is_participated_in_publicly_funded_programs"
                        onChange={formik.handleChange}
                        label="Have you or your family ever participated in any publicly funded programs such as subsidized housing (public or affordable housing programs, Section 8) employment/training programs (i.e., CETA), school lunch programs, etc.?"
                      />
                    </Grid>
                    {formik.values.is_participated_in_publicly_funded_programs === 'true' && (
                      <Grid xs={12}>
                        <TextInput
                          disabled={reviewedAndComplete}
                          countText={49}
                          label="If yes, list program(s):*"
                          setLabelHight={true}
                          values={formik.values.publicly_funded_programs}
                          name="publicly_funded_programs"
                          onChange={formik.handleChange}
                          isMissing={!formik.values.publicly_funded_programs && check}
                        />
                      </Grid>
                    )}
                    <Grid xs={12}>
                      <YesNoSwitch
                        logo="span-csu-logo"
                        disabled={reviewedAndComplete}
                        values={formik.values.is_work_primarily_to_contribute}
                        name="is_work_primarily_to_contribute"
                        onChange={formik.handleChange}
                        label="Do you or any other children in your family work primarily to contribute to household expenses?"
                      />
                    </Grid>
                    {formik.values.is_work_primarily_to_contribute === 'true' && (
                      <Grid xs={12}>
                        <TextAreaInput
                          
                          countText={2500}
                          label="If yes, explain:*"
                          values={formik.values.work_primarily_to_contribute}
                          name="work_primarily_to_contribute"
                          onChange={formik.handleChange}
                          isMissing={!formik.values.work_primarily_to_contribute && check}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </div>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-start`}>
                <div className="d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed & Complete!
                    </span>
                  </div>
                </div>
              </div>
              
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {activitiesAndHonors.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default EducationalPrograms;
